import { render, staticRenderFns } from "./UserListField.vue?vue&type=template&id=673272c7"
import script from "./UserListField.vue?vue&type=script&lang=js"
export * from "./UserListField.vue?vue&type=script&lang=js"
import style0 from "./UserListField.vue?vue&type=style&index=0&id=673272c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports